import { ChangeDetectionStrategy, Component, inject, input, model, output, signal } from '@angular/core';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faTrashCan } from '@fortawesome/free-solid-svg-icons';
import { IconsService } from 'src/app/shared/services/icons.service';

@Component({
  selector: 'app-upload-file',
  standalone: true,
  imports: [
    FontAwesomeModule
  ],
  templateUrl: './upload-file.html',
  styleUrl: './upload-file.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UploadFile {
  icons = inject(IconsService);
  file = model<File | null>(null);
  approvalComplete = input.required();
  onDelete = output<boolean>();
  faTrashCan = faTrashCan;

  onLoadFile(event: Event) {
    const input = event.target as HTMLInputElement;
    if (!input.files?.length) return;
    const file = input.files[0];
    this.file.set(file ? file : null);
  }

  previewDocument(): void {
    if (this.file()) {
      const url = URL.createObjectURL(this.file()!);
      const tab = window.open(url, '_blank');

      tab?.addEventListener('unload', () => {
        URL.revokeObjectURL(url);
      });
    }
  }

  removeFile() {
    this.file.set(null);
  }
}
